<template>
  <div class="animated fadeIn">
    <Forms ref="frmGroup"
      :title="'CADASTRO DE CONTATO EXTERNO'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      v-on:Clear="onClear"
      v-on:Back="onBack"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-3">
          <label><small v-show="form.cooperativa.required" class="text-danger">*</small> Cooperativa:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o Código da Cooperativa'"
                          v-model="form.cooperativa.value"
                          :size="form.cooperativa.maxlength"
                          :required="form.cooperativa.required"
                          :state="form.cooperativa.state"
                          autocomplete="false"></b-form-input>
          </div>
        </div>
        <div class="col-md-3">
          <label ><small v-show="form.cooperativaContato.required" class="text-danger">*</small> Contato:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o contato'"
                          v-model="form.cooperativaContato.value"
                          :size="form.cooperativaContato.maxlength"
                          :required="form.cooperativaContato.required"
                          :state="form.cooperativaContato.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-3">
          <label ><small v-show="form.emailContato.required" class="text-danger">*</small> E-mail:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o E-mail'"
                          v-model="form.emailContato.value"
                          :size="form.emailContato.maxlength"
                          :required="form.emailContato.required"
                          :state="form.emailContato.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-3">
          <label ><small v-show="form.telefoneContato.required" class="text-danger">*</small> Telefone:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o Telefone'"
                          v-model="form.telefoneContato.value"
                          :size="form.telefoneContato.maxlength"
                          :required="form.telefoneContato.required"
                          :state="form.telefoneContato.state"
                          v-mask="['(##) ####-####', '(##) #####-####']"></b-form-input>
          </div>
        </div>
      </div>
    </Forms>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'

import ContactExternalModel from '@/shared/models/configurations/contactexternalmodel.js'
import ContactExternalForms from './ce-form.js'
import ContactExternalRepository from '@/shared/http/repositories/configurations/contactexternal.js'

export default {
  name: 'ContactExternalAdd',
  mixins: [ActionsForm],
  data () {
    return {
      data: ContactExternalModel,
      form: ContactExternalForms
    }
  },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onLoad () {
    },
    onEdit (obj) {
      loading.push()
      Tools.SetValueInForm(this.form, this.data, obj)
      if (obj && obj.cooperativa) {
        this.form.cooperativa.value = parseInt(obj.cooperativa)
      }
      if (obj && obj.numero) {
        this.form.numero.value = parseInt(obj.numero)
      }
      loading.pop()
    },
    onCreate () {
      loading.push()
      ContactExternalRepository.Create(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      ContactExternalRepository.Update(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/contacts/external/components/add/ceadd.vue